import { 
  GET_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  GET_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR, 
  GET_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS,
  UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR, 
  UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS 
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_clicks_dashboard: null,
  loading: false
}

const UserClicksDashboardColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLICKS_DASHBOARD_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_clicks_dashboard: action.payload,
        loading: false
      }

    case GET_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_clicks_dashboard: action.payload,
        loading: false
      }

    case UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default UserClicksDashboardColumnPreference;
